export const mutations = {
  SET_CARRIER_CREDENTIALS(state, payload) {
    state.carrierCredentials.carrier = payload.credentials;
  },
};
